import { FetchPaymentMethodsPayload } from 'braintree-web';

export function hasNonExpiredDefaultPaymentMethod(paymentMethods: FetchPaymentMethodsPayload[]) {
  const defaultPayment = paymentMethods.find((m) => m.default);

  if (!defaultPayment) return false;
  if (defaultPayment.type !== 'CreditCard' || !defaultPayment.details) return true;
  if (!('expirationYear' in defaultPayment.details)) return false;

  const { expirationMonth, expirationYear } = defaultPayment.details;
  return new Date(`${expirationYear}/${expirationMonth}/01`) > new Date();
}
